module.exports = __webpack_public_path__ + "static/media/Tobereconfirmed2.57a03a73.png";